import { HeaderPortal } from "@/components/src/header-portal/header-portal.component";
import { DashboardJobs } from "../dashboard/components/dashboard-jobs.component";

export const AuftraegeOverviewPage: React.FC = () => {
	return (
		<div className="w-full h-full flex flex-col">
			<HeaderPortal>
				<div className="flex items-center">
					<h2 className="text-lg text-gray-800">Auftragsübersicht</h2>
				</div>
			</HeaderPortal>
			<DashboardJobs />
		</div>
	);
};
